module.exports = __webpack_public_path__ + "2d767629158a361a2f675beb0db5b2a4.svg";